import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Merge CSS classes with Tailwind
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Generate a random user ID
export function generateUserId(): string {
  return Math.random().toString(36).substring(2, 15);
}

// Generate a random session ID (6 characters)
export function generateSessionId(): string {
  return Math.random().toString(36).substring(2, 8).toUpperCase();
}
